<template>
  <div class="w-100 h-100">
    <div class="card contenedorFiltros">
      <div class="card-header">
        <div class="card-title">
          <h5 class="text-center">Buscar Bill of Lading </h5>
        </div>
      </div>
      <div class="card-body">
        <label>Seleccione una opción:</label>
        <ui-radio-group
          class="d-flex m-3"
          name="group5"
          value="id"
          vertical
          v-model="search_type"
          :options="radio_options">
        </ui-radio-group>
        <ui-textbox class="w-96 m-3"
                    :label="search_box_label"
                    :placeholder="search_box_placeholder"
                    v-model="search_value">

        </ui-textbox>
        <button class="btn btn-outline-danger btn-block" @click="search" :disabled="!search_btn_active">
          {{ search_btn_text }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// Select UI
import UiTextbox from "keen-ui/src/UiTextbox";
import UiRadioGroup from "keen-ui/src/UiRadioGroup";
import { buscarBillLadings } from "@/constants/lineas";
import { mapActions, mapState } from "vuex";

export default {
  props: ["data"],
  data() {
    return {
      search_box_label: "Buscar por número de: contenedor/booking",
      search_box_placeholder: "Ingrese número de: contenedor/booking",
      radio_options: [
        { "label": "Por número de contenedor", "value": 1 },
        { "label": "Por número de booking", "value": 2 }
      ],
      search_type: "",
      search_value: "",
      search_btn_text: "Buscar",
      search_btn_active: true
    };
  },
  components: {
    UiTextbox,
    UiRadioGroup
  },
  computed:{
    ...mapState("lineas", ["bl_search_carrier_booking_number"])
  },
  watch: {
    search_type: function(value) {
      switch (value) {
        case 1:
          this.search_box_label = "Buscar por número de contenedor";
          this.search_box_placeholder = "Ingrese número de contenedor";
          break;
        case 2:
          this.search_box_label = "Buscar por número de booking";
          this.search_box_placeholder = "Ingrese número de booking";
          break;
      }
    },
    bl_search_carrier_booking_number: async function(_value) {
      if (_value) {
        this.search_type = 2;
        this.search_value = this.bl_search_carrier_booking_number;
        await this.search();
      }
    }
  },
  methods: {
    ...mapActions("lineas", [
      "actionSetDataResultadoBooking",
      "actionSetDataResultadoContainers",
      "actionSetDataResultadoBillLadings"
    ]),
    async search() {
      if (this.search_type === "") {
        return this.$vToastify.error(
          "Debe seleccionar un tipo de búsqueda",
          "Error: Tipo de búsqueda"
        );
      }
      if (this.search_value === "") {
        return this.$vToastify.error(
          "Debe ingresar un parámetro de búsqueda",
          "Error: No. Contenedor/Booking"
        );
      }

      this.loadingButton(false);

      let data = {
        search_type: this.search_type ?? null,
        search_value: this.search_value ?? null
      };

      let dataDB = await buscarBillLadings(data);

      this.actionSetDataResultadoBooking(dataDB.booking);
      this.actionSetDataResultadoContainers(dataDB.container);
      this.actionSetDataResultadoBillLadings(dataDB.bill_lading);

      this.loadingButton(true);
    },
    loadingButton(active) {
      if (!active) {
        this.$vToastify.loader("Por favor, espere...");
        this.search_btn_text = "Buscando, espere...";
        this.search_btn_active = active;
      } else {
        this.$vToastify.stopLoader();
        this.search_btn_text = "Buscar";
        this.search_btn_active = active;
      }
    }
  }
};
</script>
<style>
.boton {
    height: 50px;
    width: 80px;
}

.radioButton {
    width: 100px;
    position: horizontal;
}
</style>
